import React,{useState,useEffect,useContext} from 'react';

import {RequestStatusId} from '../../ApplicationConfig/constants';
import { useTranslation } from "react-i18next";
import {UserInfoContext} from '../../StateObjects/UserInfoContext';
import {useParams, useHistory} from 'react-router-dom'
import {Auth} from '../../Api/auth';
import VettingRequest from './index';
import Snackbar from '../CommonComponents/Snackbar';
import { useMsal } from '@azure/msal-react';

export default function VettingRequestForm(){
  const {t} = useTranslation();
  const {requestId} = useParams();
  const [refreshForm, setRefreshForm] = useState(false);
  const [request, setRequest] = useState(null);
  const {userInfo} = useContext(UserInfoContext);

  const {instance}=useMsal();
  
  const history = useHistory();

  const [snackbarState, setSnackbarState] = React.useState({
    severity: "success",
    message: "",
    open: false
  });

  const handleRefreshForm=React.useCallback(()=>{
    setRefreshForm(!refreshForm);
  }, [refreshForm]);

  useEffect(()=> {
    Auth.authorizedFetch("/api/getRequest/"+requestId,{},instance)
    .then(res=>res.json())
    .then(response=>{
      if(response.statusCode===200){
        setRequest(response.data);
      }else{
        if(Object.prototype.hasOwnProperty.call(response, "customMessageKey")){
          setSnackbarState({
            severity: "error",
            message: t("applicationErrorMessage.request." + response.customMessageKey),
            open: true
          });
        }else{
          setSnackbarState({
            severity: "error",
            message: error,
            open: true
          });
        }
      }
    })
    .catch((error)=>{
      setSnackbarState({
        severity: "error",
        message: error,
        open: true
      });
    });
  }, [requestId, refreshForm]);

  useEffect(()=>{
    if(history.location.state && history.location.state.newRequest){
      setSnackbarState({
        severity: "success",
        message: t("notifications.vettingRequestCreated"),
        open: true
      });
    }
  }, []);

  if(request === null){
    return <></>;
  }

  return (
    <>
      <VettingRequest 
        request={request} 
        readOnly={!(
          (request.researcher.account === userInfo.id && (request.status.id === RequestStatusId.Draft || request.status.id === RequestStatusId.UpdateRequest)) ||
          (request.primaryAnalyst.account === userInfo.id && request.status.id === RequestStatusId.DisclosureAnalysis)
        )} 
        analystEditFlag={request.primaryAnalyst.account === userInfo.id && request.status.id === RequestStatusId.DisclosureAnalysis}
        handleRefreshForm={handleRefreshForm}
      />
      <Snackbar 
        message={snackbarState.message}
        severity={snackbarState.severity}
        open={snackbarState.open}
        handleClose={()=>{
          setSnackbarState({...snackbarState,
            message: "",
            open: false
          });
        }}
      />
    </>
  );
}